import { ErrorPage } from '@/components/errors';
import { useGetAccountServices, useGetPersonalInfo } from '@/hooks/api';
import { ModuleName, Screen, templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useRequestAppAccess } from './-hooks/request-app-access.hook';
import { type ServiceProps } from './-model/props';
import { ServicesLight } from './-skins';
import { useRemoveServiceAccess } from './-hooks/remove-access.hook';
import { useGetApplications } from '@/hooks/api/applications.hook';

export const Route = createFileRoute('/(services)/services')({
  component: RouteComponent,
  errorComponent: ErrorPage,
  staticData: {
    module: ModuleName.Account,
    screen: Screen.Services,
  },
});

function RouteComponent() {
  const { data: services, isLoading: servicesLoading } = useGetAccountServices();
  const { data: personalInfo } = useGetPersonalInfo();
  const { data: applications, isLoading: applicationsLoading } = useGetApplications();
  const { mutateAsync } = useRequestAppAccess();
  const { mutate: removeServices, isPending: removeServicesLoading } = useRemoveServiceAccess();
  const [appIdRequestingAccess, setAppIdRequestingAccess] = useState<string | null>(null);
  const props: ServiceProps = {
    servicesLoading,
    services: services ?? {
      Type: 'Guest',
      DefaultAccountId: '',
      Holder: {
        HouseHoldName: '',
        PictureUri: '',
        PrimaryUserDisplayName: '',
        ServiceAccounts: [],
        UsernameAliases: [],
      },
    },
    defaultAccountId: personalInfo?.DefaultAccountId,
    applications: applications ?? [],
    applicationsLoading,
    appIdRequestingAccess,
    requestAccess: (id) => {
      setAppIdRequestingAccess(id);
      mutateAsync({ id }).finally(() => setAppIdRequestingAccess(null));
    },
    removeServices: removeServices,
    removeServicesLoading,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: ServiceProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <ServicesLight {...props} />,
  };
}
